/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Categories_DetailInputs */

const en_common_header_explore_categories_detail = /** @type {(inputs: Common_Header_Explore_Categories_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse by domain`)
};

const zh_common_header_explore_categories_detail = /** @type {(inputs: Common_Header_Explore_Categories_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按领域浏览`)
};

/**
* | output |
* | --- |
* | "Browse by domain" |
*
* @param {Common_Header_Explore_Categories_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_categories_detail = /** @type {((inputs?: Common_Header_Explore_Categories_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Categories_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_categories_detail(inputs)
	return zh_common_header_explore_categories_detail(inputs)
});
export { common_header_explore_categories_detail as "common.header.explore.categories.detail" }